var React = require('react');

function UserGroup (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7 8a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm0 1c2.15 0 4.2.4 6.1 1.09L12 16h-1.25L10 20H4l-.75-4H2L.9 10.09A17.93 17.93 0 0 1 7 9zm8.31.17c1.32.18 2.59.48 3.8.92L18 16h-1.25L16 20h-3.96l.37-2h1.25l1.65-8.83zM13 0a4 4 0 1 1-1.33 7.76 5.96 5.96 0 0 0 0-7.52C12.1.1 12.53 0 13 0z"}));
}

UserGroup.defaultProps = {"viewBox":"0 0 20 20"};

module.exports = UserGroup;

UserGroup.default = UserGroup;
